import * as yup from "yup";

export function tradeSchema() {
  return yup
    .object({
      isPrice: yup.boolean(),
      coinId: yup.number().required("کوین مبدا اشتباه است"),
      coinMasterId: yup.number().required("کوین مقصد اشتباه است"),
      sideId: yup.number().required("نوع بازار ترید اشتباه است"),
      walletTypeId: yup.number().required("نوع ولت اشتباه است"),
      amountTypeId: yup.number().required("نوع پرداخت اشتباه است"),
      tradeTypeId: yup.number().required("نوع ترید اشتباه است"),
      amount: yup.string().nullable().required("وارد کردن مقدار الزامی است"),
      price: yup.string().when("isPrice", {
        is: true,
        then: yup.string().nullable().required("وارد کردن قیمت الزامی است"),
      }),
    })
    .required();
}
